const formatBytes = b => { // b = number of bytes
  if (b === 0) {
    return '0';
  }
  if (b < 1024) {
    return `${b} Bytes`;
  }
  if (b < 1048576) {
    return `${(b / 1024).toFixed(2)} KB`;
  }
  if (b < 1073741824) {
    return  `${(b / 1048576).toFixed(2)} MB`;
  }
  return `${(b / 1073741824).toFixed(2)} GB`;
};

export default formatBytes;



// WEBPACK FOOTER //
// ./src/utilities/formatBytes.js